<div>
  <app-customer-profile-grid
    [dataSource]="customerAddressDataSource"
    [columnsToDisplay]="columnsToDisplay"
    [titleToDisplay]="titleToDisplay"
    [actions]="actions"
  ></app-customer-profile-grid>
</div>
